import { useState } from "react";
import { toast } from "sonner";
import { Send, Copy } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { OFFER_LABELS } from "../../lib/labels";

export function InviteClient() {
  const [f, setF] = useState({ email: "", name: "", offer: "vetements", message: "" });
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState("");
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const send = async () => {
    if (!f.email) return toast.error("Email du client requis");
    setBusy(true);
    try { const r = await api.post("/admin/invite", f); setLink(r.data.link); toast.success(r.data.email_sent ? "Invitation envoyée" : "Lien créé (email en file d'attente)"); } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  const copy = async () => { const l = link || `${window.location.origin}/demande/${f.offer}?utm_source=atelier&utm_medium=magasin`; await navigator.clipboard.writeText(l); toast.success("Lien copié"); };
  return (
    <section className="bg-white border border-[#E8E2D8] p-5 grid gap-3" data-testid="invite-client">
      <div><p className="k-eyebrow">Client en magasin ou au téléphone</p><h2 className="font-display text-xl mt-1">Envoyer le formulaire à un client</h2><p className="text-xs text-[#8C857B] mt-1">Le client reçoit un lien ; sa demande arrive ici, dans les dossiers, et dans son espace client.</p></div>
      <div className="grid sm:grid-cols-3 gap-2">
        <input className="k-input py-2 text-sm" type="email" placeholder="Email du client" value={f.email} onChange={up("email")} data-testid="invite-email" />
        <input className="k-input py-2 text-sm" placeholder="Prénom / nom (facultatif)" value={f.name} onChange={up("name")} data-testid="invite-name" />
        <select className="k-input py-2 text-sm" value={f.offer} onChange={up("offer")} data-testid="invite-offer">{Object.entries(OFFER_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      </div>
      <textarea rows={2} className="k-input py-2 text-sm" placeholder="Message personnalisé (facultatif)" value={f.message} onChange={up("message")} data-testid="invite-message" />
      <div className="flex flex-wrap gap-2 items-center">
        <button className="k-btn k-btn-sm" onClick={send} disabled={busy} data-testid="invite-send"><Send size={14} /> {busy ? "Envoi…" : "Envoyer par email"}</button>
        <button className="k-btn-outline k-btn-sm" onClick={copy} data-testid="invite-copy"><Copy size={14} /> Copier le lien du formulaire</button>
        {link && <span className="text-xs text-[#8C857B] truncate max-w-full" data-testid="invite-link">{link}</span>}
      </div>
    </section>
  );
}
